<div
  class="d-flex flex-column justify-content-start mt_bg position-relative"
  style="min-height: 100vh !important; overflow: hidden"
>
  <app-header></app-header>

  <div class="content-holder z-40 relative">
    <div class="content-data bg-transparent" style="padding-top: 130px">
      <div class="flex flex-col w-full items-center justify-center">
        <div *ngIf="institution$"
             class="glass-card flex flex-col items-center justify-center intro-x col-md-8 px-5 cursor-pointer module-card mb-3 rounded-md p-3">
          <div>
            <!--            {{instLogo}}-->
            <img [src]="instLogo" class="h-10"/>
          </div>
          <div>
            <p class="text-primary-500 text-xl font-bold text-center mb-1">{{ institution$.institutionName }}
              ({{ institution$.institutionShortform }})</p>
          </div>
        </div>
        <div class="col-md-8 grid grid-cols-12 gap-4">

          <ng-container *ngFor="let module of mainMenu; let i = index">
            <div class="col-span-12 md:col-span-4 hover-scale-up cursor-pointer module-name"
                 (mouseenter)="hoverIndex = i"
                 (mouseleave)="hoverIndex = -1"
                 *ngxPermissionsOnly="module.permission"
                 routerLink="{{ module.route }}"
            >
              <div class="bg-white shadow-sm group-hover:bg-primary-500 text-primary-500 group-hover:text-white flex flex-col h-28 items-start hover:text-white hover:!bg-primary-500 ease-in-out p-3 rounded-xl">
                <div class="bg-primary-200 group-hover:bg-white p-2 h-10 w-10 flex flex-col items-center justify-center rounded-md">
                  <mat-icon class="" *ngIf="module.icon && module.iconType == 'SVG'" [svgIcon]="module.icon" style="font-size: 30px !important;"></mat-icon>
                </div>
                <h3 class="text-xl font-medium whitespace-nowrap mt-2">
                  {{ module.name }}
                </h3>
              </div>
            </div>
          </ng-container>

          @if (userProfile?.userEmail === 'vanessa.mhando@eganet.go.tz') {
            <div
              class="col-span-12 md:col-span-4 hover-scale-up rounded-2xl group shadow-sm border-[1px] border-white p-1 cursor-pointer"
              routerLink="/kiosk">

              <div class="relative">
                <div class="bg-white text-hpc-primary-500 flex flex-col h-28 items-start ease-in-out p-3 rounded-xl">
                  <div
                    class="bg-hpc-accent  group-hover:bg-hpc-accent-600 p-2 h-10 w-10 flex flex-col items-center justify-center rounded-md">
                    <app-font-awesome-icon iconName="kiosk"></app-font-awesome-icon>
                  </div>
                  <h3 class="text-xl font-medium whitespace-nowrap mt-2">
                    HPC Kiosk Portal
                  </h3>
                </div>

                <div class="overflow-hidden absolute right-4 top-0 w-[50%] h-full flex justify-end">
                  <img class=" -rotate-45 object-contain w-full opacity-10" src="/assets/img/posta.png"
                       alt="Posta logo"/>
                </div>
              </div>

            </div>
          }

        </div>
      </div>

    </div>
    <div class="version bg-primary-500 text-white -bottom-2 absolute">
      Copyright &copy; {{ fullYear }}. Developed and Maintained by e-Government Authority.
    </div>
  </div>

  <ul class="background">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
</div>
